<script lang="ts">
  // components
  import Modal from "@shared/svelte/Components/Modal.svelte";
  import Icon from "@shared/svelte/Components/Icon.svelte";

  // types
  import type { PaymentInstrument } from "@shared/types/PaymentInstrument";

  // props
  export let showModals: object;
  export let paymentInstruments: PaymentInstrument[] = [];
  export let instrumentToRemove: PaymentInstrument;
  export let iconType: (type: PaymentInstrument) => void;
  export let onCloseModals: () => void;
  export let onMakeDefault: (instrument: PaymentInstrument) => void;
  export let onDelete: (instrument: PaymentInstrument) => void;

  // data
  let selectedInstrumentId: number;

  // functions
  const saveDefaultAndDeleteInstrument = () => {
    const selectedInstrument = paymentInstruments.find(
      instrument => instrument.id == selectedInstrumentId
    );
    onMakeDefault(selectedInstrument);
    onDelete(instrumentToRemove);
    onCloseModals();
  };
  const deleteInstrument = () => {
    onDelete(instrumentToRemove);
    onCloseModals();
  };
  const onClose = () => {
    selectedInstrumentId = null;
    onCloseModals();
  };

  // reactives
  $: nickname = instrumentToRemove?.nickname;
  $: setDefaultPaymentMethod =
    paymentInstruments.length >= 2 && instrumentToRemove?.default_instrument;

</script>

<style>
  .payment-instruments div:last-child {
    border: none;
  }

</style>

<Modal
  bind:show={showModals["PaymentMethodUpdateModal"]}
  closeOnBackgroundClick={true}
  fizzModal={true}
  size={"medium"}
>
  <section class="fizz-inset-square-16">
    <header class="fizz-space-between fizz-stack-16">
      <h4 class="fizz-heading-4">Confirm Delete Payment Method</h4>
      <div id="close-payment-type-modal" on:click|preventDefault={onClose}>
        <Icon type="X" extraClassNames="fizz-text-brand cursor-pointer" height="16" width="16" />
      </div>
    </header>
    <div class="fizz-stack-24">
      <p class="fizz-stack-16">
        Deleting this payment method will cancel all currently pending and scheduled payments
        associated with this payment method. Any previously pending payments will need to be paid
        again. It will also cancel autopay. Are you sure you want to delete this payment method?
      </p>
    </div>

    {#if setDefaultPaymentMethod}
      <section class="fizz-stack-32 payment-instruments">
        {#each paymentInstruments as instrument}
          <div class="fizz-stack-16 fizz-border-bottom">
            <label class="fizz-flex-row fizz-stack-16" for={instrument.nickname}>
              <input
                bind:group={selectedInstrumentId}
                type="radio"
                class="fizz-radio-button"
                name={instrument.nickname}
                value={instrument.id}
              />
              <div class="fizz-flex-row">
                <Icon type={iconType(instrument)} height="24" width="34" />
                <p>{instrument.nickname}</p>
              </div>
            </label>
          </div>
        {/each}
      </section>
    {/if}

    <footer class="fizz-flex-row fizz-justify-end">
      <button class="fizz-button-text" on:click|preventDefault={onClose}>Cancel</button>
      <button
        class="fizz-button-secondary fizz-button-small"
        disabled={setDefaultPaymentMethod ? !selectedInstrumentId : false}
        on:click|preventDefault={setDefaultPaymentMethod
          ? saveDefaultAndDeleteInstrument
          : deleteInstrument}
      >
        {#if setDefaultPaymentMethod}
          Select &amp; Delete
        {:else}
          Delete
        {/if}
      </button>
    </footer>
  </section>
</Modal>
